function arrayToDict (array, key) {
  const result = {}
  for (let i = 0; i < array.length; i++) {
    result[array[i][key]] = array[i]
  }
  return result
} 

/*
  TPMS mutations
*/
export default {

  SET_LOADING (state, payload) {
    state.loading = payload
  },

  SET_ACTIVE_LIST_LOADING (state, payload) {
    state.activeListLoading = payload
  },

  setActiveTpmsEventsList (state, payload) {
    payload.sort(function (a, b) {
      if (a.receivedAt < b.receivedAt) {
        return -1
      }
      if (a.receivedAt > b.receivedAt) {
        return 1
      }
      return 0
    })
    state.activeList = payload
    state.activeDictList = Object.assign({}, arrayToDict)
  },
  setTpmsEventsList (state, payload) {
    // Sort payload
    payload.sort(function (a, b) {
      if (a.receivedAt < b.receivedAt) {
        return -1
      }
      if (a.receivedAt > b.receivedAt) {
        return 1
      }
      return 0
    })
    state.list = payload
    state.dictList = Object.assign({}, arrayToDict(payload, 'id'))
  },

  setUnitsToTheEvents (state, { rootState }) {
    const warning = []
    // map underinflationEvents
    const events = []
    const tpmsEvents = {}
    for (let i = 0; i < state.list.length; i++) {
      const event = state.list[i]
      events.push({
        ...event,
        unit: rootState.units.dictList[event.unitId]
      })
      if (event.pressureResolved === false || event.pressureResolved === null) {
        event.unit = event.unitId ? rootState.units.dictList[event.unitId] : null
        warning.push(event)
      } else if (rootState.units.dictList[event.unitId]) {
        // dictList can be partial while units page in; grouping an event with no
        // unit would render a nameless row. state.list below still keeps them all
        if (tpmsEvents[event.unitId] === undefined) {
          tpmsEvents[event.unitId] = {}
          tpmsEvents[event.unitId].unit = rootState.units.dictList[event.unitId]
          tpmsEvents[event.unitId].events = []
        }
        tpmsEvents[event.unitId].events.push({
          ...event,
          unit: rootState.units.dictList[event.unitId]
        })
      }
    }
    state.list = events
    // Convert tpmsWarnings to array
    state.tpmsWarnings = warning
    // Convert tpmsEvents to array
    const tpmsEventList = []
    for (const key in tpmsEvents) {
      const unit = tpmsEvents[key]
      unit.eventsType = []
      for (let i = 0; i < unit.events.length; i++) {
        const event = unit.events[i]
        if (!unit.eventsType.includes(event.eventType)) {
          unit.eventsType.push(event.eventType)
        }
      }
      tpmsEventList.push(unit)
    }
    state.tpmsEvents = tpmsEventList
  },
  // eslint-disable-next-line no-unused-vars
  toggle (_, payload) {}
}